export const run = (io) => io();
